import { baseApi } from "./apiConfig";
export const getBidOfferDetails = async (payload = {
    listingType: "AUCN",
    propertyStatus: null,
    filterSelected: "N",
    buyerEmailId: null,
    propertyAddress: "",
    type: "",
    pageNo: 1
}) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.post(`/portal/getBidOfferDetails?_=${timestamp}`, payload);
        return response.data;
    } catch (error) {
        console.error('Error getting bid offer details:', error);
        throw error;
    }
};

export const getCifDetails = async (bidIds = []) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.post('/portal/api/AUCN/cifDetails', bidIds);
        return response.data;
    } catch (error) {
        console.error('Error getting CIF details:', error);
        throw error;
    }
};
export const getBidDetailsById = async (bidId) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/api/getBidDetailsById/${bidId}`, {
            params: {
                _: timestamp
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error getting bid details:', error);
        throw error;
    }
};

export const getBidHistory = async (propertyId, options = {}) => {
    try {
        const {
            limit = 10,
            offset = 0,
            order = 'asc',
            timeStamp = new Date().getTime()
        } = options;

        const response = await baseApi.get(`/portal/bidHistory/${propertyId}`, {
            params: {
                timeStamp,
                limit,
                offset,
                order,
                _: new Date().getTime()
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error getting bid history:', error);
        throw error;
    }
};



export const getSoldPropertiesDetails = async () => {
    try {
        const timestamp = new Date().getTime();
       const response = await baseApi.get(`/portal/api/getBuyerFilterDetails/SLD?_=${timestamp}`);

        // const response = await baseApi.post(`/portal/api/getBuyerFilterDetails/SLD?_=${timestamp}`);
        return response.data;
    } catch (error) {
        console.error('Error getting bid offer details:', error);
        throw error;
    }
};

export const withdrawBidById = async (payload) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.post(`/portal/api/withdrawBid?_=${timestamp}`, payload);
        return response.data;
    } catch (error) {
        console.error('Error getting bid offer details:', error);
        throw error;
    }
};

export const getAutoBidDetails = async (payload) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.post(`/portal/api/autoBidDetails?_=${timestamp}`, payload);
        return response.data;
    } catch (error) {
        console.error('Error getting bid offer details:', error);
        throw error;
    }
};

export const editAutoBidAmount = async (payload) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.post(`/portal/api/editAutoBidAmount?_=${timestamp}`, payload);
        return response.data;
    } catch (error) {
        console.error('Error getting bid offer details:', error);
        throw error;
    }
};



export const getBuyerFilterDetails = async () => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/api/getBuyerFilterDetails/ACTV?_=${timestamp}`);
        console.log('Buyer filter details response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching buyer filter details:', error);
        throw error;
    }
};

export const submitBid = async (payload) => {
    try {
        const timestamp = new Date().getTime();

      const response = await baseApi.post(`/portal/v2.0/submitBid?_=${timestamp}`, payload);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getBidContingency = (listingId, buyerPaymentOption, bidAmount) => {
   
    return baseApi
      .get(
        `/portal/api/bidContigency/${listingId}/${buyerPaymentOption}/${bidAmount}`,
      )
      .then(response => {
        return response.data;
      })
      .catch(e => {
        log('error:', e);
      });
  };

export const getOfferDetails = async(id) =>{
 try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/viewOfferDetails/${id}`, {
            params: {
                _: timestamp
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error getting bid details:', error);
        throw error;
    }
}
  
export const getTrasaction = async(page)=>{
try {
        const timestamp = new Date().getTime();
        const response = await baseApi.get(`/portal/buyerdashboard/previousTransactions/${page}`, {
            params: {
                _: timestamp
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error getting bid details:', error);
        throw error;
    }
}

export const bidDepositChargeDetails = async (payload) => {
    try {
        const timestamp = new Date().getTime();
        const response = await baseApi.post(`/portal/api/bidDepositChargeDetails?_=${timestamp}`, payload);
        return response.data;
    } catch (error) {
        console.error('Error submitting bid deposit charge details:', error);
        throw error;
    }
};
